import type { ReactNode } from 'react';
import { AlertIcon, CheckIcon } from '../icons';

const TONES = {
  error: 'bg-danger-soft text-danger border-danger/25',
  success: 'bg-ok-soft text-ok border-ok/25',
  info: 'bg-brand-soft text-brand-strong border-brand/20',
} as const;

export function Notice({ tone, children }: { tone: keyof typeof TONES; children: ReactNode }) {
  return (
    <div role={tone === 'error' ? 'alert' : 'status'} className={`flex gap-2.5 rounded-control border p-3 text-[14px] ${TONES[tone]}`}>
      <span className="mt-0.5 shrink-0">{tone === 'success' ? <CheckIcon size={18} /> : <AlertIcon size={18} />}</span>
      <div>{children}</div>
    </div>
  );
}
